// extracted by css-extract-rspack-plugin
export default {"root":"ClosingText_root__IGUtr"};